/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */

export enum ActionTypesGDM {
  GET_GDM_CONFIG = "GET_GDM_CONFIG",
  GET_GDM = "GET_GDM"
}

export enum MutationTypesGDM {
  CLEAR_CONFIG_STATE_IN_TRANSFER_DESIGN = 'CLEAR_CONFIG_STATE_IN_TRANSFER_DESIGN',
  SET_GDM_CONFIG = "SET_GDM_CONFIG",
  SET_GDM = "SET_GDM",
  UPDATE_GDM = "UPDATE_GDM"
}
